module.exports = __webpack_public_path__ + "img/kaifapiao.8158ed95.png";